import { put, takeLatest } from "redux-saga/effects";

import axios from "axios";

import { simApi } from "../../../utility/api/apiList";

import singleSimPageType from "./singleSimPageType";

import {
  successFetchedSingleSimPage,
  failureFetchedSingleSimPage,
} from "./singleSimPageAction";

export function* startfetchingSingleSimPage(action) {
  try {
    const response = yield axios.get(`${simApi}${action.id}/`);
    yield (document.title = response.data.name);
    const handlesuccess = yield put(successFetchedSingleSimPage(response.data));
  } catch (error) {
    const handlefailed = yield put(
      failureFetchedSingleSimPage(error.response.data.detail)
    );
  }
}

export function* fetchSingleSimPage() {
  yield takeLatest(
    singleSimPageType.START_FETCHING_SINGLE_SIM_PAGE,
    startfetchingSingleSimPage
  );
}
